import React from 'react';
import { Link } from 'react-router-dom';
import DateText from './DateText';
/**
 * EventCard
 * -------------------------------------------------------
 * Shared card for the homepage slider and the /events listing.
 *
 * Props:
 *  - event
 *  - className
 *  - showUpcomingPill: when true, shows an "Upcoming" pill for
 *    events where isPast is false. Off by default so the
 *    homepage slider is unaffected.
 *
 * Two Links (image, and the tag/heading/meta block via
 * `className="contents"`) rather than one wrapping everything,
 * because the brochure button is a real <a> and an <a> can't
 * legally nest inside another <a>.
 */
const BoothIcon = ({ className }) => (
  <svg     className="w-4 h-4 shrink-0"    viewBox="0 0 24 24"    fill="none"    stroke="rgb(35, 180, 85)"    strokeWidth="2"    strokeLinecap="round"    strokeLinejoin="round"
    aria-hidden="true"  >
    <path d="M3 9h18l-2-5H5L3 9Z" />
    <path d="M3 9v11h18V9" />
    <path d="M8 20V9M16 20V9" />
    <path d="M10 13h4v7h-4z" />
  </svg>
);

const PinIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="rgb(35, 180, 85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const CalendarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="rgb(35, 180, 85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);  

export default function EventCard({
  event,
  className = '',
  showUpcomingPill = false,
}) {
  const isUpcoming = showUpcomingPill && !event.isPast;

  return (
    <div
      className={`relative flex flex-col md:flex-row w-full bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 h-full md:min-h-[350px] hover:shadow-xl transition-shadow ${className}`}
    >
     <Link
  to={`/events/${event.slug}`}
  className="block w-full md:w-[45%] md:flex-shrink-0 md:self-center"
>
  <img
    src={event.image}
    alt={event.name}
    className="w-full h-auto block"
  />
</Link>

      <div className="flex-1 min-w-0 p-5 sm:p-6 md:p-8 flex flex-col justify-center">
        <Link to={`/events/${event.slug}`} className="contents">
          {(event.tag || isUpcoming) && (
            <div className="flex flex-wrap items-center gap-2 self-start mb-3">
              {/* {event.tag && (
                <span className="inline-block bg-green text-white font-poppins font-semibold uppercase tracking-wide text-sm px-3 py-1 rounded-full">
                  {event.tag}
                </span>
              )} */}
              {isUpcoming && (
                <span className="inline-flex items-center gap-1.5 bg-white text-green border border-green font-poppins font-semibold uppercase tracking-wide text-sm px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-green" />
                  Upcoming
                </span>
              )}
            </div>
          )}

          <h3 className="font-gilroybold text-lg sm:text-xl md:text-3xl mb-3">
            {event.name}
          </h3>

          <div className="space-y-2 font-poppins text-lg">
            <div className="flex items-center gap-2">
              <CalendarIcon className="w-4 h-4 flex-shrink-0 text-green" />
              <span>{event.date}</span>
            </div>
            <div className="flex items-center gap-2">
              <PinIcon className="w-4 h-4 flex-shrink-0 text-green" />
              <span>{event.location}</span>
            </div>
            {event.tag === 'Exhibitor' && event.boothNumber && (
              <div className="flex items-center gap-2">
                <BoothIcon className="w-4 h-4 flex-shrink-0 text-green" />
                
                <span>Booth {event.boothNumber}</span>
              </div>
            )}
          </div>
        </Link>

        {/* {event.brochure && (
          <a
            href={event.brochure}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 self-start font-poppins font-semibold text-sm border border-green text-green rounded-md px-4 py-2 hover:bg-green hover:text-white transition-colors"
          >
            <svg
              className="w-4 h-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 3v12m0 0l-4-4m4 4l4-4" />
              <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
            </svg>
            Download Brochure
          </a>
        )} */}
      </div>
    </div>
  );
}